export default __webpack_public_path__ + "static/media/Back.125f1143.svg";